import React from "react";
import { Instagram, Facebook, Send } from "lucide-react";

// Use WhatsApp inline SVG (lucide doesn't ship a brand WhatsApp icon).
const WhatsAppIcon = ({ size = 16, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    className={className}
  >
    <path d="M19.05 4.92A10 10 0 0 0 4.07 18.34L3 22l3.78-1.05A10 10 0 1 0 19.05 4.92Zm-7.04 15.32a8.27 8.27 0 0 1-4.23-1.16l-.3-.18-2.24.62.6-2.18-.2-.32a8.32 8.32 0 1 1 6.37 3.22Zm4.55-6.22c-.25-.13-1.47-.72-1.69-.8-.23-.08-.4-.13-.56.13-.16.25-.65.8-.79.97-.15.16-.29.18-.54.06-.25-.13-1.05-.39-2-1.23a7.5 7.5 0 0 1-1.38-1.72c-.15-.25-.02-.39.1-.51.11-.11.25-.29.37-.43.13-.15.17-.25.25-.41.08-.16.04-.31-.02-.43-.07-.13-.56-1.35-.76-1.85-.2-.49-.41-.42-.56-.43h-.48a.93.93 0 0 0-.67.31c-.23.25-.88.86-.88 2.1 0 1.24.9 2.43 1.02 2.6.13.16 1.77 2.7 4.29 3.79.6.26 1.06.41 1.43.52a3.46 3.46 0 0 0 1.58.1c.48-.07 1.47-.6 1.68-1.18.21-.59.21-1.09.15-1.19-.06-.1-.23-.16-.48-.29Z" />
  </svg>
);

const ICONS = {
  whatsapp: { Icon: WhatsAppIcon, label: "WhatsApp", href: "https://wa.me/6287777881016?text=Halo%20Across%20Indonesia" },
  instagram: { Icon: Instagram, label: "Instagram", href: "https://instagram.com/acrossindonesia" },
  facebook: { Icon: Facebook, label: "Facebook", href: "https://facebook.com/acrossindonesia" },
  telegram: { Icon: Send, label: "Telegram", href: "https://t.me/acrossindonesia" },
};

const DEFAULT_ORDER = ["whatsapp", "instagram", "facebook", "telegram"];

/**
 * Reusable social media icon row.
 * variant: "light" (for dark backgrounds) | "dark" (for light backgrounds)
 * size: pixel size of the icon
 * compact: true → tight pill icons; false → larger circular icons
 */
export default function SocialIcons({
  items = DEFAULT_ORDER,
  variant = "dark",
  size = 16,
  compact = true,
  className = "",
  testidPrefix = "social",
}) {
  const isLight = variant === "light";
  const baseBtn = compact
    ? "w-9 h-9 rounded-full flex items-center justify-center transition-all"
    : "w-11 h-11 rounded-full flex items-center justify-center transition-all";

  const colorBtn = isLight
    ? "bg-white/10 hover:bg-white/20 text-white border border-white/20"
    : "bg-stone-100 hover:bg-stone-200 text-slate-700 border border-stone-200";

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {items.map((key) => {
        const def = ICONS[key];
        if (!def) return null;
        const { Icon, label, href } = def;
        return (
          <a
            key={key}
            href={href}
            target="_blank"
            rel="noreferrer"
            aria-label={label}
            data-testid={`${testidPrefix}-${key}`}
            className={`${baseBtn} ${colorBtn}`}
          >
            <Icon size={size} />
          </a>
        );
      })}
    </div>
  );
}
